































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class VoucherFail extends Vue {
    @Prop({ type: Array })
    voucherFail!: Voucher.VoucherImport[];
    @Prop({ type: Array })
    failSubject!: Voucher.VoucherImport[];

    @Prop({ type: String })
    message!: string;

}
